<template>
  <div>
    <el-dialog
      :title="titleWord"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
      >
        <el-form-item
          label="岗位名称:"
          prop="name"
        >
          <el-input
            v-model="ruleForm.name"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item
          label="岗位类别:"
          prop="type"
          style="width: 49%;display: inline-block"
        >
          <el-select
            v-model="ruleForm.type"
            placeholder="请选择"
            style="width: 100%"
            @change="typeChange"
          >
            <el-option
              v-for="item in unitTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="岗位有效期限:"
          prop="timeScope"
          style="width: 49%;display: inline-block"
        >
          <el-date-picker
            v-if="ruleForm.type !== 'Fixed'"
            v-model="ruleForm.timeScope"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
          <el-select
            v-else
            v-model="ruleForm.timeScope"
            style="width:100%"
          >
            <el-option
              v-for="item in ruleForm.workLimitOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="岗位招聘人数:"
          prop="needNum"
          style="width: 49%;display: inline-block"
        >
          <el-input
            v-model="ruleForm.needNum"
            maxlength="5"
          />
        </el-form-item>
        <el-form-item
          label="月薪:"
          prop="money"
          style="width: 49%;display: inline-block"
        >
          <el-input
            v-model="ruleForm.money"
            maxlength="10"
          ><span slot="suffix">元/每月</span></el-input>
        </el-form-item>
        <el-form-item
          label="申请限制"
          prop="radio"
        >
          <el-radio-group
            v-model="ruleForm.radio"
            @change="radioChange"
          >
            <el-radio
              style="margin-bottom:10px;"
              label="1"
            ><span style="display:inline-block;width:150px;">所有学生</span> <span>
              <span>月工资上限:</span>

              <el-form-item
                prop="infinitMoneyFirLimit"
                style="display:inline-block;"
              >
                <el-input
                  v-model="ruleForm.infinitMoneyFirLimit"
                  maxlength="10"
                  style="width: 100%"
                />
              </el-form-item>

              <span style="font-size: 12px;color: #909399">元/月（有则填写无则不填）</span>
            </span>
            </el-radio>
            <el-radio label="2">
              <span style="display:inline-block;width:150px;">家庭经济困难学生</span>
              <span>
                <span>月工资上限:</span>
                <el-form-item
                  prop="infinitMoneySecLimit"
                  style="display:inline-block;"
                >
                  <el-input
                    v-model="ruleForm.infinitMoneySecLimit"
                    style="width: 100%"
                    maxlength="10"
                  />
                </el-form-item>
                <span style="font-size: 12px;color: #909399">元/月（有则填写无则不填）</span>
              </span>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <b-col v-if="ruleForm.type === 'Temporary'" cols="12">
          <el-form-item
            label="申请材料:"
            prop="name"
          >
            <el-upload
              class="upload-demo"
              :action="uploadURL"
              :on-success="handleSuccess"
              :on-remove="handleRemove"
              :before-upload="beforeUpload"
              multiple
              :limit="1"
            >
              <el-button size="small" type="primary">
                点击上传
              </el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过8M
              </div>
            </el-upload>
          </el-form-item>

        </b-col>
        <el-form-item
          label="指导教师:"
          prop="teacher"
          style="width: 49%;display: inline-block"
        >
          <el-input v-model="ruleForm.teacher"  maxlength="60"/>
        </el-form-item>
        <el-form-item
          label="联系电话:"
          prop="phoneNum"
          style="width: 49%;display: inline-block"
        >
          <el-input v-model="ruleForm.phoneNum"  maxlength="40"/>
        </el-form-item>
        <el-form-item
          label="申请岗位截止时间:"
          prop="limitTime"
        >
          <el-date-picker
            v-model="ruleForm.limitTime"
            value-format="timestamp"
            style="width: 100%"
            type="datetime"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item
          label="工作时间说明(200字以内)："
          prop="workInstruction"
        >
          <el-input
            v-model="ruleForm.workInstruction"
            maxlength="200"
            :autosize="{minRows: 4}"
            type="textarea"
            placeholder="如一周工作几天，一天工作几个小时"
          />
        </el-form-item>
        <el-form-item
          label="岗位职责(200字以内)："
          prop="unitDuty"
        >
          <el-input
            v-model="ruleForm.unitDuty"
            maxlength="200"
            :autosize="{minRows: 4}"
            type="textarea"
            placeholder="岗位需要做些什么"
          />
        </el-form-item>
        <el-form-item
          label="招聘要求(200字以内)："
          prop="requirements"
        >
          <el-input
            v-model="ruleForm.requirements"
            maxlength="200"
            :autosize="{minRows: 4}"
            type="textarea"
            placeholder="对应聘的学生有什么要求"
          />
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="comfirmUnit"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { includeZInt } from '@/tool/utils'
import { jobService } from '@/api/index'
import moment from 'moment'
// import { uploadFileURL } from '@/api/api'

export default {
  name: 'ReleaseUnit',
  props: {
    callBackObj: Object,
    titleWord: {
      type: String,
      default: '提示',
    },
  },
  data() {
    const mustBeNum = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('该项不能为空'))
      } else if (!includeZInt(value)) {
        callback(new Error('请输入正整数'))
      } else {
        callback()
      }
    }
    return {
      // 非数字验证
      dialogVisible: false,
      poorList: [
        { id: 1, name: '一般困难' },
        { id: 2, name: '特殊困难' },
      ],
      unitTypeList: [
        {
          id: 'Fixed',
          name: '固定岗位',
        },
        {
          id: 'Temporary',
          name: '临时岗位',
        },
      ],
      ruleForm: {
        name: '',
        type: 'Temporary',
        timeScope: [],
        workLimitOptions: [], // 固定岗位期限
        radio: null,
        infinitMoneyFirLimit: 300, // 所有学生的最高工资
        infinitMoneySecLimit: 300, // 家庭经济困难学生最高工资
        limits: [],
        workInstruction: '', // 工作时间说明
        unitDuty: '', // 岗位职责
        requirements: '', // 招聘要求
        needNum: '', // 招聘人数
        money: '', // 每小时薪资
        teacher: '', // 指导老师
        phoneNum: '', // 电话号码
        limitTime: '', // 截止日期
      },
      rules: {
        name: [{ required: true, message: '请输入岗位名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        timeScope: [{ required: true, message: '请选择岗位有效期限', trigger: 'blur' }],
        needNum: [{ required: true, validator: mustBeNum, trigger: 'blur' }],
        money: [{ validator: mustBeNum, trigger: 'blur' }],
        radio: [{ required: true, message: '请选择限制条件', trigger: 'blur' }],
        // phoneNum: [{required: true, message: '请输入联系电话', trigger: 'blur'}],
        limitTime: [{ required: true, message: '请选择时间段', trigger: 'blur' }],
        infinitMoneyFirLimit: [],
        infinitMoneySecLimit: [],
        // infinitMoneySecLimit: [{ required: true, message: '请输入活动名称', trigger: 'blur' }, { min: 1, max: 10, message: '长度在 3 到 5 个字符', trigger: 'blur' }]
        // workInstruction: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
        // unitDuty: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
        // requirements: [{ required: true, message: '该项不能为空', trigger: 'blur' }]
      },
    }
  },
  computed: {
    uploadURL() {
      return `${process.env.BASE_URL}/api/file/upload-file`
    },
  },
  watch: {
    callBackObj: {
      handler(val) {
        if (val) {
          this.ruleForm.name = val.name
          this.ruleForm.type = val.jobType
          this.ruleForm.timeScope = val.jobType === 'Temporary' ? [] : ''
          this.ruleForm.infinitMoneyFirLimit = 300 // 所有学生的最高工资
          this.ruleForm.infinitMoneySecLimit = 300 // 家庭经济困难学生最高工资
          this.ruleForm.limits = []
          this.ruleForm.workInstruction = val.workDesc
          // this.ruleForm.workLimitOptions = val.pVaiName
          this.ruleForm.unitDuty = val.jobContent
          this.ruleForm.requirements = val.requirements
          this.ruleForm.needNum = val.numberOfNeed
          this.ruleForm.teacher = val.teacher
          this.ruleForm.phoneNum = val.phone
          this.ruleForm.money = val.money
          this.ruleForm.limitTime = ''
          // if (val.jobType === 'Temporary') {
          //   this.ruleForm.timeScope = [this.$moment(val.startTime).format('YYYY-MM-DD'), this.$moment(val.endTime).format('YYYY-MM-DD')]
          // }
          // 判断贫困等级
          if (val.jobLimitList[0].poorLevel === 0) {
            this.ruleForm.radio = '1'
            this.ruleForm.limits = []
          } else {
            this.ruleForm.radio = '2'
            this.ruleForm.limits = val.jobLimitList
          }
        } else {
          this.ruleForm = {
            name: '',
            type: 'Temporary',
            timeScope: [],
            radio: '',
            infinitMoneyFirLimit: 300, // 所有学生的最高工资
            infinitMoneySecLimit: 300, // 家庭经济困难学生最高工资
            limits: [],
            workInstruction: '', // 工作时间说明
            unitDuty: '', // 岗位职责
            requirements: '', // 招聘要求
            needNum: '', // 招聘人数
            money: '', // 每小时薪资
            teacher: '', // 指导老师
            phoneNum: '', // 电话号码
            limitTime: '', // 截止日期
          }
          this.$refs.ruleForm.clearValidate()
        }
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate()
        })
      },
      deep: true,
    },
  },
  mounted() {

  },
  methods: {
    handleRemove(file, fileList) {
      this.files = fileList
    },
    // eslint-disable-next-line consistent-return
    beforeUpload(file) {
      const fileNameAttr = file.name.split('.')
      const suffix = fileNameAttr[fileNameAttr.length - 1]
      const passSuffix = ['jpg', 'png']
      if (!passSuffix.includes(suffix)) {
        this.$message({
          message: '选择文件类型不正确',
          type: 'error',
        })
        return false
      }
    },
    handleSuccess(response, file, fileList) {
      if (response.status) {
        this.files = fileList
        this.ruleForm.file = JSON.stringify(response.data)
      } else {
        this.ruleForm.file = fileList.slice(0, -1)
        this.$message({
          message: '上传失败',
          type: 'error',
        })
      }
    },
    radioChange() {
      if (this.ruleForm.radio === '1') {
        this.rules.infinitMoneyFirLimit = [{ pattern: /^\d{1,10}$/, message: '请输入正确格式', trigger: 'blur' }]
        this.rules.infinitMoneySecLimit = []
        this.$refs.ruleForm.clearValidate('infinitMoneySecLimit')
      } else if (this.ruleForm.radio === '2') {
        this.rules.infinitMoneyFirLimit = []
        this.rules.infinitMoneySecLimit = [{ pattern: /^\d{1,10}$/, message: '请输入正确格式', trigger: 'blur' }]
        this.$refs.ruleForm.clearValidate('infinitMoneyFirLimit')
      }
    },
    typeChange() {
      // 主要生成一个默认时间，解决非空验证
      if (this.ruleForm.type === 'Fixed') {
        this.queryFixedPositionDate()
        // this.ruleForm.timeScope = [this.$moment()._d, this.$moment().add(1, 'month')._d]
        // this.$refs.ruleForm.clearValidate('timeScope')
      } else if (this.ruleForm.type === 'Temporary') {
        this.ruleForm.timeScope = []
      }
    },
    // 删除限制条件
    delLimitItem(index) {
      this.ruleForm.limits.splice(index, 1)
    },
    // 查询固定岗位有效期
    queryFixedPositionDate() {
      jobService()._positionFixedDate().then(res => {
        this.ruleForm.workLimitOptions = []
        if (res.status && res.data) {
          this.ruleForm.workLimitOptions.push(...res.data)
        }
      })
    },
    // 确定按钮
    comfirmUnit() {
      if (this.ruleForm.type === 'Temporary' && this.ruleForm.money > 350) {
        this.$message.warning('临时岗位工资上限限制350以内')
        return
      }
      if (this.ruleForm.type === 'Temporary' && !this.ruleForm.file) {
        this.$message.warning('发布临时岗位 必须上传审核材料')
        return
      }
      let fixedtimeScope = [moment()._d, moment().add(1, 'month')._d]
      let pvaiId = this.ruleForm.timeScope
      if (this.ruleForm.type !== 'Fixed') {
        fixedtimeScope = this.ruleForm.timeScope
        pvaiId = ''
      }
      // eslint-disable-next-line consistent-return
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // 获取所有参数
          const params = {
            deadTime: this.ruleForm.limitTime,
            endTime: fixedtimeScope[1],
            startTime: fixedtimeScope[0],
            pvaiId, // 为固定岗位id
            jobContent: this.ruleForm.unitDuty,
            jobLimitList: [],
            jobType: this.ruleForm.type,
            money: Number(this.ruleForm.money),
            name: this.ruleForm.name,
            numberOfNeed: Number(this.ruleForm.needNum),
            phone: this.ruleForm.phoneNum,
            requirements: this.ruleForm.requirements,
            teacher: this.ruleForm.teacher,
            workDesc: this.ruleForm.workInstruction,
            file: this.ruleForm.file,
          }
          // 贫困等级需要与后台确认
          if (this.ruleForm.radio === '1') {
            const jobLimitItem = { monthMoneyCap: this.ruleForm.infinitMoneyFirLimit, poorLevel: 0 }
            params.jobLimitList.push(jobLimitItem)
          } else {
            const jobLimitItem = { monthMoneyCap: this.ruleForm.infinitMoneySecLimit, poorLevel: 1 }
            params.jobLimitList.push(jobLimitItem)
          }
          if (params.jobType === 'Fixed') {
            params.endTime = ''
            params.startTime = ''
          }
          this.$emit('addCofirm', params)
        } else {
          return false
        }
      })
    },
    clear() {
      this.$refs.ruleForm.clearValidate()
    },

  },
}
</script>

<style scoped lang="less">
/deep/.el-dialog__body {
  height: 600px;
  overflow-y: auto;
}
</style>
